export default __webpack_public_path__ + "static/media/concert.bf6de165.png";